module.exports = __webpack_public_path__ + "static/media/vacuumlabs.77418d9a.jpeg";